export default __webpack_public_path__ + "static/media/image5.1a8558d4.png";